module.exports = __webpack_public_path__ + "img/thumb_29.e84aadb5.jpg";